<!--
 * @Description:
 * @Author: jin
 * @Date: 2019-10-14 11:31:04
 -->
<template>
  <div id="app">
    <router-view/>
    <audio src="" id="eventAudio"></audio>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue